import {Breadcrumb} from "antd";
import React, {useCallback, useContext, useState} from "react";
import {AppContextContext} from "../../Contexts";
import {Link} from "react-router-dom";
import {DocumentTitle} from "../DocumentTitle";
import * as globalStyles from "../App.module.css";
import AiUsageOverview, {AiCreditUsage} from "./AiUsageOverview";
import Tip from "../common/Tip";
import AiCreditUsageIndicator from "../common/AiCreditUsageIndicator";
import {effectiveAiCreditLimit} from "../../domain/Organization";

function AiUsagePage() {
    const appContext = useContext(AppContextContext);
    const title = "AI usage";
    const isAdmin = appContext.user.isSystemAdmin();
    const userAiTier = isAdmin ? undefined : appContext.user.organization?.aiTier;
    const userAiCreditLimit = isAdmin ? undefined : effectiveAiCreditLimit(appContext.user.organization);
    const [monthlyCreditUsage, setMonthlyCreditUsage] = useState<AiCreditUsage>();
    const onMonthlyCreditUsageChange = useCallback((usage?: AiCreditUsage) => {
        setMonthlyCreditUsage(usage);
    }, []);

    return (
        <DocumentTitle title={title}>
            <>
                <Breadcrumb className={globalStyles["common__breadcrumb"]}
                            items={[
                                {title: appContext.config?.appName},
                                {title}
                            ]}
                />

                <div style={{marginBottom: 16}}>
                    <h1 style={{display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: monthlyCreditUsage ? 4 : undefined}}>
                        <span>{title}</span>
                        {userAiTier?.name && (
                            <span style={{fontSize: "0.55em", fontWeight: 500, color: "#595959"}}>
                                Tier: {userAiTier.name}
                            </span>
                        )}
                    </h1>
                    {monthlyCreditUsage && (
                        <AiCreditUsageIndicator
                            label="Used this month"
                            used={monthlyCreditUsage.used}
                            limit={monthlyCreditUsage.limit}
                        />
                    )}
                </div>

                {!isAdmin && (
                    <Tip
                        id="AiUsagePage.purpose"
                        style={{marginBottom: 12}}
                        message="AI usage shows how many requests, tokens, and credits your organization consumed over the selected period."
                        description={<>Usage is driven by <Link to="/interests">interests</Link> and defined <Link to="/definitions/ai-extractors">AI extractors</Link>. If you need a higher limit, please contact us at <a href="mailto:sales@sonpo.cz">sales@sonpo.cz</a>.</>}
                    />
                )}

                <AiUsageOverview
                    organizationId={isAdmin ? undefined : appContext.user.organization?.id}
                    showOrganizationBreakdown={isAdmin}
                    aiTier={userAiTier}
                    aiCreditLimit={userAiCreditLimit}
                    onMonthlyCreditUsageChange={onMonthlyCreditUsageChange}
                />
            </>
        </DocumentTitle>
    );
}

export default AiUsagePage;
